function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

import Capitan from '../../code/js/Capitan/Capitan';
import CapSmartResize from '../../code/js/Capitan/es6/CapSmartResize';
import Navigation from './functions/navigation';
import ShowInfo from './functions/helper/showInfo';
var _ = {
  defaults: {
    componentName: 'Navigation'
  }
};
var o = _.defaults;
var isNavigationInitialized = false;
export var init = function init() {
  /**
   * Navigation initializing
   * @description try catch async function because of dynamic navigation type import @see navigationMobile.js & @see navigationDesktop.js
   */
  var initNavigation = /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              _context.next = 3;
              return Navigation().setInitialClass().then(function (resolve) {
                if (typeof resolve !== 'undefined') {
                  var currentComponent = new resolve.default();
                  currentComponent.initEvents();
                }
              });

            case 3:
              _context.next = 8;
              break;

            case 5:
              _context.prev = 5;
              _context.t0 = _context["catch"](0);
              ShowInfo('is-active');

            case 8:
              console.timeEnd(o.componentName);
              return _context.abrupt("return", true);

            case 10:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[0, 5]]);
    }));

    return function initNavigation() {
      return _ref.apply(this, arguments);
    };
  }();

  if (!isNavigationInitialized) {
    initNavigation();
  }

  CapSmartResize(function () {
    if (Capitan.assertBreakpoint('ht', 'md')) {
      initNavigation();
    }
  });
};